import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

const configs = {
  dev: {
    apiKey: 'AIzaSyBFMtJNxxQhiDK5BFVrog3G8xffxQVm0v4',
    authDomain: 'magictouch-dev.firebaseapp.com',
    databaseURL: 'https://magictouch-dev-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'magictouch-dev',
    storageBucket: 'magictouch-dev.firebasestorage.app',
    messagingSenderId: '632962734570',
    appId: '1:632962734570:web:122a2532e89da61e65fa93',
    measurementId: 'G-NGFYV7KKY4',
  },
  demo: {
    apiKey: 'AIzaSyBEAplELp3tVEIJXTPgb-CEl7I1rDKgGdU',
    authDomain: 'magictouch-demo-242b3.firebaseapp.com',
    databaseURL: 'https://magictouch-demo-242b3-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'magictouch-demo-242b3',
    storageBucket: 'magictouch-demo-242b3.firebasestorage.app',
    messagingSenderId: '43635457990',
    appId: '1:43635457990:web:72406fed263782388c3cc7',
  },
  prod: {
    apiKey: 'AIzaSyDVyH-6cpGxYlBVYLQyd-vpsA50yKxKiro',
    authDomain: 'magictouch-prod.firebaseapp.com',
    databaseURL: 'https://magictouch-prod-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'magictouch-prod',
    storageBucket: 'magictouch-prod.firebasestorage.app',
    messagingSenderId: '234473089510',
    appId: '1:234473089510:web:854938f765011c27608e27',
    measurementId: 'G-5XMSVX5LK4',
  },
};

function getEnvironment() {
  const hostname = window.location.hostname;

  const devHosts = ['localhost', 'dev-desk.runport.run', 'dev-desk.skiday.app'];
  const demoHosts = ['demo-desk.runport.run', 'demo-desk.skiday.app'];
  const prodHosts = ['desk.runport.run', 'desk.skiday.app'];

  if (devHosts.includes(hostname)) {
    return 'dev';
  }
  if (demoHosts.includes(hostname)) {
    return 'demo';
  }
  if (prodHosts.includes(hostname)) {
    return 'prod';
  }
  // デフォルトはdev
  return 'dev';
}

const env = getEnvironment();
const firebaseConfig = configs[env];

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const functions = getFunctions(app, 'asia-northeast1');

if (import.meta.env.DEV) {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectDatabaseEmulator(rtdb, 'localhost', 9000);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
